import axios from "axios";

const http = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL || "http://localhost:4040/api",
  withCredentials: true,
});

// Optional: simple bearer token if you add auth later
http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");

  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }

  return cfg;
});

export { http };
export default http;